import React from "react";
import pufferJacketProductImage from "../../images/pufferJacketProductImage.webp";
import ScanFingerPrintAnimation from "../../images/ScanFingerPrintAnimation.gif";
import MultiplePaymentMethods from "../../images/MultiplePaymentMethods.webp";
import MultiplePaymentMethodsMobile from "../../images/MultiplePaymentMethodsMobile.webp";
import InstallmentsAndEpp from "../../images/InstallmentsAndEpp.webp";
import InstallmentsAndEppMobile from "../../images/InstallmentsAndEppMobile.webp";
import InstallmentsAndEppTablet from "../../images/InstallmentsAndEppTablet.webp";
import ScanQRCodeAnimation from "../../images/ScanQRCodeAnimation.gif";
import AutomatedLogisticsSchedulingAnimation from "../../images/AutomatedLogisticsSchedulingAnimation.gif";

function WhatWeOfferSection() {
  const commonStyles = {
    outerSection:
      "sticky w-full xl:max-w-[80vw] mx-auto h-fit drop-shadow-[6px_6px_0_black]",
    wrapperSection:
      "relative w-[318px] sm:w-[537px] xl:w-[1053px] h-[390px] sm:h-[300px] xl:h-[412px] mx-auto border border-black bg-white rounded-b-[20px]",
    topHeading: {
      section:
        "absolute bottom-full w-full sm:w-[54.74%] xl:w-[35%] h-fit border border-black rounded-t-[20px] pt-2.5 sm:pt-0 xl:pt-2 pb-2.5 sm:pb-0 xl:pb-3",
      text: "text-sm sm:text-xs xl:text-base font-HalvarBreitBold xl:font-HalvarBreitMedium text-center leading-[40px] sm:leading-[40px] xl:leading-[40px] -tracking-[2%]",
    },
    innerSection: {
      section:
        "w-full flex flex-col sm:flex-row justify-between pl-3 sm:pl-3.5 xl:pl-11 pr-3 sm:pr-2 xl:pr-12 pt-4 sm:pt-8 xl:pt-12",
      heading:
        "hidden sm:block text-[22px] xl:text-[46px] font-HalvarBreitBold text-[#100C08] leading-[25.48px] xl:leading-[53px] -tracking-[2%]",
      paragraph:
        "text-xs xl:text-xl font-HalvarBreitMedium xl:font-HalvarBreitRegular text-[#100C08] leading-[21px] xl:leading-[28px] -tracking-[1%]",
    },
  };

  return (
    <section className="mt-40 mb-14 w-full relative flex flex-col gap-y-32">
      <h2 className="hidden xl:block sticky top-32 text-[52px] font-HalvarBreitMedium uppercase text-black leading-[34px] -tracking-[1.04] text-center">
        What Do we offer?
      </h2>
      {/* 1-1 - Zero Pay Checkout */}
      <section
        className={`top-[11rem] sm:top-60 xl:top-72 ${commonStyles.outerSection}`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} xl:-left-[1px] bg-[#9B03D0] text-white`}
          >
            <p className={`${commonStyles.topHeading.text}  text-white`}>
              Zero Pay Checkout
            </p>
          </section>
          <section
            className={`${commonStyles.innerSection.section} items-center xl:items-end gap-y-4`}
          >
            <section className="w-full sm:w-[245px] xl:w-[554px] flex flex-col gap-y-7 translate-y-0 xl:translate-y-3">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                Zero Pay Checkout
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                Zero Pay Checkouts is the new Cash on Delivery, except it's
                more... digital
                <br />
                Offer your customers the flexibility to be charged only after
                the order has been delivered
                <br />
                <br />
                Meanwhile we secure that transaction for you!
              </p>
            </section>
            <section className="w-60 xl:w-72 h-fit border border-black/20 rounded-2xl pt-3.5 xl:pt-7 px-4 flex flex-col items-center mx-auto xl:mx-0">
              <div className="flex items-center gap-1 w-full">
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3.5 xl:w-[18px]"
                >
                  <path
                    d="M6.60758 2L3.89258 4.7225"
                    stroke="#100C08"
                    strokeWidth="1.25"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.3926 2L14.1076 4.7225"
                    stroke="#100C08"
                    strokeWidth="1.25"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.5 6.38745C1.5 4.99995 2.2425 4.88745 3.165 4.88745H14.835C15.7575 4.88745 16.5 4.99995 16.5 6.38745C16.5 7.99995 15.7575 7.88745 14.835 7.88745H3.165C2.2425 7.88745 1.5 7.99995 1.5 6.38745Z"
                    stroke="#100C08"
                    strokeWidth="1.25"
                  />
                  <path
                    d="M7.32007 11V13.6625"
                    stroke="#100C08"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10.77 11V13.6625"
                    stroke="#100C08"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.625 8L3.6825 14.48C3.9225 15.935 4.5 17 6.645 17H11.1675C13.5 17 13.845 15.98 14.115 14.57L15.375 8"
                    stroke="#100C08"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                  />
                </svg>
                <h3 className="text-xs xl:text-base font-gtAmericaBold text-[#100C08] leading-[14px] xl:leading-[19px] -tracking-[2%] xl:-tracking-[0.32px]">
                  Order Summary
                </h3>
              </div>

              <section className="w-full flex items-start gap-1.5 mt-3 xl:mt-6 pb-3 border-b border-black/[23%] ">
                <div className="w-11 h-11 xl:w-16 xl:h-16 aspect-square border border-[#100C08] rounded overflow-hidden">
                  <img
                    src={pufferJacketProductImage}
                    alt="Puffer Jacket Product"
                    className="w-full h-full object-cover object-top"
                    width={1012}
                    height={1365}
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-[#100C08] font-HalvarBreitRegular text-[10px] xl:text-xs leading-[13.18px] xl:leading-[15.82px] -tracking-[2%] xl:-tracking-[0.24px]">
                    Puffer jacket
                  </p>
                  <p className="text-[#100C08] font-HalvarBreitRegular text-[8px] xl:text-[10px] leading-[10.55px] xl:leading-[15.82px] -tracking-[2%] xl:-tracking-[0.24px]">
                    Black | Small | Qty:x1
                  </p>
                  <p className="text-[#100C08] font-HalvarBreitBold text-[10px] xl:text-xs leading-[13.18px] xl:leading-[15.82px] -tracking-[0.24px]">
                    AED 1,800.00
                  </p>
                </div>
              </section>
              <div className="w-full flex items-center justify-between mt-3 xl:mt-[18px]">
                <p className="text-[10px] xl:text-xs font-HalvarBreitRegular text-[#100C08] leading-[13.18px] xl:leading-[15.82px]">
                  Subtotal
                </p>
                <p className="text-[10px] xl:text-xs font-HalvarBreitBold text-[#100C08] leading-[13.18px] xl:leading-[15.82px]">
                  AED 1800.00
                </p>
              </div>
              <div className="mt-0.5 xl:mt-3.5 mb-3 xl:mb-6 bg-[#9B03D0] flex items-center justify-between py-3.5 xl:py-5 px-5 rounded-md w-[123%] shadow-[4px_4px_0_black]">
                <p className="text-xs xl:text-lg font-HalvarBreitRegular text-white leading-[8px] xl:leading-[12px] min-w-max">
                  Due Today
                </p>
                <p className="text-xs xl:text-lg font-HalvarBreitBold text-white leading-[8px] xl:leading-[12px] min-w-max">
                  AED 00.00
                </p>
              </div>
            </section>
          </section>
        </section>
      </section>

      {/* 1-2 - 1 click - Express Checkout */}
      <section
        className={`${commonStyles.outerSection} top-[13.7rem] sm:top-60 xl:top-72`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} left-0 right-0 sm:ml-auto xl:mx-auto bg-[#FF3075] text-white`}
          >
            <p className={`${commonStyles.topHeading.text} text-white`}>
              1 click - Express Checkout
            </p>
          </section>
          <section
            className={`${commonStyles.innerSection.section} items-center gap-y-9`}
          >
            <section className="w-full sm:w-[275px] xl:w-[540px] flex flex-col gap-y-7 pl-0 sm:pl-2.5 xl:pl-0">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                1 click - Express Checkout
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                Our 1-Click Checkout combined with Biometrics (Passkeys) gets
                your customers done in less than 15 seconds!
                <br />
                <br />
                Faster checkouts, higher conversions. <br /> ‘nuff said!
              </p>
            </section>
            <section className="relative w-[245px] h-[156px] sm:w-[207px] sm:h-[130px] xl:w-[371px] xl:h-[237px] border border-black/20 rounded-2xl flex flex-col items-center ">
              <img
                src={ScanFingerPrintAnimation}
                alt="Scan FingerPrint Animation"
                className="absolute top-0 left-0 w-full h-full object-contain object-center"
                width={800}
                height={600}
                loading="lazy"
              />
            </section>
          </section>
        </section>
      </section>

      {/* 1-3 - Multiple Payment Methods  */}
      <section
        className={`${commonStyles.outerSection} top-[16.7rem] sm:top-[17rem] xl:top-72`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} xl:-right-[1px] bg-[#FF884B] text-white`}
          >
            <p className={`${commonStyles.topHeading.text} text-[#100C08]`}>
              Multiple Payment Methods
            </p>
          </section>
          <section
            className={`${commonStyles.innerSection.section} items-center gap-y-9`}
          >
            <section className="w-full sm:w-[278px] xl:w-[545px] flex flex-col gap-y-3 xl:gap-y-7 pl-0 sm:pl-2.5 xl:pl-0">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                Multiple Payment Methods
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                Who doesn’t like options?
                <br />
                Give your customers flexible ways to pay with multiple payment
                methods enabled right outta the box!
                <br />
                <br />
                More ways to pay = 68% reduction in abandoned checkouts
              </p>
            </section>
            <section className="relative w-[365px] h-[295px] hidden xl:flex items-center">
              <img
                src={MultiplePaymentMethods}
                alt="Multiple Payment Methods"
                className="absolute top-0 left-0 w-full h-full object-contain object-center"
                width={369}
                height={202}
                loading="lazy"
              />
            </section>
            <section className="relative w-full sm:w-[204px] h-[165px] sm:h-[143px] flex xl:hidden items-center">
              <img
                src={MultiplePaymentMethodsMobile}
                alt="Multiple Payment Methods"
                className="absolute top-0 left-0 w-full h-full object-contain object-center"
                width={273}
                height={170}
                loading="lazy"
              />
            </section>
          </section>
        </section>
      </section>

      {/* 2nd */}
      {/* 2-1 - Installments & EPP */}
      <section
        className={`${commonStyles.outerSection} top-[19.7rem] sm:top-[17rem] xl:top-72 xl:translate-x-10 xl:translate-y-[3.25rem]`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} sm:right-0 xl:right-auto xl:-left-[1px] bg-[#FFC644] text-white`}
          >
            <p className={`${commonStyles.topHeading.text} text-[#100C08]`}>
              Installments & EPP
            </p>
          </section>
          <section
            className={`${commonStyles.innerSection.section} items-start xl:items-center gap-y-9`}
          >
            <section className="w-full sm:w-[270px] xl:w-[540px] flex flex-col gap-y-3 xl:gap-y-7 pl-0 sm:pl-2.5 xl:pl-0">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                Installments & EPP
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                Offer micro-financing options and watch your sales grow!
                <br />
                Give customers the flexibility to split or defer payments
                <br />
                <br />
                And that’s how you increase your Basket Size!
              </p>
            </section>
            <section className="w-full sm:w-fit pt-0 sm:pt-2 xl:pt-0 pr-0 sm:pr-5 xl:pr-0">
              <p className="text-xs xl:text-base font-HalvarBreitBold xl:font-HalvarBreitMedium text-black text-center mb-3">
                Instalments upto <br className="hidden xl:block" /> 36{" "}
                <br className="hidden sm:block xl:hidden" /> months with
              </p>
              <section className="relative w-full sm:w-[200px] xl:w-[355px] h-[175px] xl:h-[205px] flex items-center">
                <img
                  src={InstallmentsAndEpp}
                  alt="Multiple Payment Methods"
                  className="absolute top-0 left-0 w-full h-full object-contain object-center hidden xl:block"
                  width={387}
                  height={227}
                  loading="lazy"
                />
                <img
                  src={InstallmentsAndEppMobile}
                  alt="Multiple Payment Methods"
                  className="absolute top-0 left-0 w-full h-full object-contain object-center block sm:hidden"
                  width={291}
                  height={115}
                  loading="lazy"
                />
                <img
                  src={InstallmentsAndEppTablet}
                  alt="Multiple Payment Methods"
                  className="absolute top-0 left-0 w-full h-full object-contain object-center hidden sm:block xl:hidden"
                  width={169}
                  height={178}
                  loading="lazy"
                />
              </section>
            </section>
          </section>
        </section>
      </section>
      {/* 2-2 - Payment Links & QR Codes */}
      <section
        className={`${commonStyles.outerSection} top-[22.7rem] sm:top-[19rem] xl:top-72 xl:translate-x-10 xl:translate-y-[3.25rem]`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} left-0 right-0 xl:mx-auto bg-[#311847] text-white`}
          >
            <p className={`${commonStyles.topHeading.text} text-white`}>
              Payment Links & QR Codes
            </p>
          </section>

          <section
            className={`${commonStyles.innerSection.section} items-center gap-y-9`}
          >
            <section className="w-full sm:w-[345px] xl:w-[725px] flex flex-col gap-y-3 xl:gap-y-7 pl-0 sm:pl-2.5 xl:pl-0">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                Payment Links & QR Codes
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                The most feature rich Payment Link & QR Code generator, ever!
                <br />
                And it comes with a completely customizable Checkout Page with
                all the payment methods enabled already.
                <br />
                <br />
                Now get your customers to checkout from anywhere!
              </p>
            </section>
            <section className="w-fit pr-0 sm:pr-2.5 xl:pr-0">
              <section className="relative w-[245px] h-[146px] sm:w-[127px] sm:h-[127px] xl:w-[300px] xl:h-[210px] flex items-center">
                <img
                  src={ScanQRCodeAnimation}
                  alt="Scan QR Code Animation"
                  className="absolute top-0 left-0 w-full h-full object-contain object-center"
                  width={250}
                  height={250}
                  loading="lazy"
                />
              </section>
            </section>
          </section>
        </section>
      </section>
      {/* 2-3 - Automated Logistics Scheduling */}
      <section
        className={`${commonStyles.outerSection} top-[24.9rem] sm:top-[17rem] xl:top-72 xl:translate-x-10 xl:translate-y-[3.25rem]`}
      >
        <section className={`${commonStyles.wrapperSection}`}>
          <section
            className={`${commonStyles.topHeading.section} sm:-right-[1px] bg-[#DFB2F4] text-white`}
          >
            <p className={`${commonStyles.topHeading.text} text-[#100C08]`}>
              Automated Logistics Scheduling
            </p>
          </section>
          <section
            className={`${commonStyles.innerSection.section} items-center gap-y-9`}
          >
            <section className="w-full sm:w-[315px] xl:w-[705px] flex flex-col gap-y-3 xl:gap-y-7 pl-0 sm:pl-2.5 xl:pl-0">
              <h2 className={`${commonStyles.innerSection.heading}`}>
                Automated Logistics Scheduling
              </h2>
              <p className={`${commonStyles.innerSection.paragraph}`}>
                For the 1st time ever!
                <br />
                A payment solution that can speak to your delivery modules, read
                statuses, push orders to delivery systems & automate payment
                capturing accordingly
                <br />
                <br />
                No more endless customizations, We care about your peace.
              </p>
            </section>
            <section className="w-fit pl-0 sm:pl-2.5 xl:pl-0">
              <section className="relative w-[153px] h-[153px] sm:w-[175px] sm:h-[175px] xl:w-[242px] xl:h-[242px] flex items-center">
                <img
                  src={AutomatedLogisticsSchedulingAnimation}
                  alt="Automated Logistics Scheduling Animation"
                  className="absolute top-0 left-0 w-full h-full object-contain object-center"
                  width={250}
                  height={250}
                  loading="lazy"
                />
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  );
}

export default WhatWeOfferSection;
